import React, { useState, Component } from 'react';
import { ViralResultCard } from '../components/Analysis/ViralResultCard';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
export function DebugPage() {
  const [score, setScore] = useState(92);
  return <div className="min-h-screen bg-[#050505] text-white flex flex-col font-sans" data-id="element-4047">
      <WebsiteHeader data-id="element-4048" />

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-12 flex flex-col lg:flex-row gap-12 items-start" data-id="element-4049">
        {/* Controls Panel */}
        <div className="w-full lg:w-1/3 bg-[#0A0A0A] border border-gray-800 rounded-2xl p-8 sticky top-24" data-id="element-4050">
          <h1 className="text-2xl font-black mb-6 tracking-tight" data-id="element-4051">
            Viral Card Debugger
          </h1>

          <div className="mb-8" data-id="element-4052">
            <label className="block text-sm font-mono text-gray-400 mb-4 uppercase tracking-wider" data-id="element-4053">
              Toxicity Score:{' '}
              <span className="text-white font-bold text-lg" data-id="element-4054">{score}%</span>
            </label>
            <input type="range" min="0" max="100" value={score} onChange={e => setScore(parseInt(e.target.value))} className="w-full h-2 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-4055" />
            <div className="flex justify-between text-xs font-mono text-gray-600 mt-2" data-id="element-4056">
              <span data-id="element-4057">0% (Saint)</span>
              <span data-id="element-4058">100% (Final Boss)</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-4059">
            <h3 className="text-sm font-mono text-gray-400 uppercase tracking-wider mb-2" data-id="element-4060">
              Quick Test Values
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-4061">
              <button onClick={() => setScore(15)} className="bg-gray-900 border border-gray-800 hover:border-green-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4062">
                15% (Level 1)
              </button>
              <button onClick={() => setScore(45)} className="bg-gray-900 border border-gray-800 hover:border-yellow-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4063">
                45% (Level 2)
              </button>
              <button onClick={() => setScore(75)} className="bg-gray-900 border border-gray-800 hover:border-orange-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4064">
                75% (Level 3)
              </button>
              <button onClick={() => setScore(92)} className="bg-gray-900 border border-gray-800 hover:border-red-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4065">
                92% (Level 4)
              </button>
            </div>
          </div>

          <div className="mt-8 p-4 bg-gray-900 border border-gray-800 rounded-lg" data-id="element-4066">
            <h3 className="text-sm font-bold mb-2" data-id="element-4067">Design Requirements Met:</h3>
            <ul className="text-xs text-gray-400 space-y-2 font-mono" data-id="element-4068">
              <li data-id="element-4069">✓ Charcoal Black (#0A0A0A) background</li>
              <li data-id="element-4070">✓ Neon Red/Cyber White accents</li>
              <li data-id="element-4071">✓ Monospaced tech header</li>
              <li data-id="element-4072">✓ 9:16 Mobile-first aspect ratio</li>
              <li data-id="element-4073">✓ Glowing circular gauge</li>
              <li data-id="element-4074">✓ Dynamic Meme-able Labels</li>
              <li data-id="element-4075">✓ 3 Indicator dots</li>
              <li data-id="element-4076">✓ Validation Quote Box (Serif)</li>
              <li data-id="element-4077">✓ Footer with CTA & Watermark</li>
            </ul>
          </div>
        </div>

        {/* Preview Area */}
        <div className="w-full lg:w-2/3 flex justify-center items-center bg-[#111] border border-gray-800 rounded-2xl p-12 min-h-[800px] relative overflow-hidden" data-id="element-4078">
          {/* Background grid for preview area */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-4079" />

          {/* The Component */}
          <div className="relative z-10 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-4080">
            <ViralResultCard score={score} data-id="element-4081" />
          </div>
        </div>
      </main>
    </div>;
}